import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectCostAnalysisItem  {
    _originalTypeClassName = "zPMO.BO.ProjectCostAnalysisItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectCostAnalysisItem.translate = translateService;
}
this.Id = null;
this.Budget = null;
this.Description = null;
this.Date = moment().toDate();
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Budget:any;
Description:any;
Date:any;
Project:any;
Product:any;
FiscalYear:any;
Subproduct:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
if (oldValue != null) {
Domain.Project.removeCostAnalysis(oldValue, $this);
}
Domain.Project.addCostAnalysis(value, $this);
}
}
static setProduct = ($this, value) => {
var oldValue = $this.Product;
$this.Product = value;
if (value != null) {
}
}
static setFiscalYear = ($this, value) => {
var oldValue = $this.FiscalYear;
$this.FiscalYear = value;
if (value != null) {
}
}
static setSubproduct = ($this, value) => {
var oldValue = $this.Subproduct;
$this.Subproduct = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}